import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Poker6Player() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "poker6";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);
  const [activeTab, setActiveTab] = useState("hands");

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
     gameName={"Poker 6 Players"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container poker6player"> */}
      {/* <div className="casino-header"> */}
      {/* <span className="casino-name">
            Poker 6 Players
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span>
          <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>110250425140729</span>
            </small>
          </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
          <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>110250425140729</span>
            </span>
          </div>
        </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box">
                <iframe src="/mediaplayer/poker6/bb4a1de6-3565-492b-a437-d599df423712?ip=122.160.119.41" />
              </div> */}
      {/* </div> */}
      {/* <div className="casino-video-cards">
              <div>
                <div className="flip-card-container">
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
      {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">4</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">4</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail">
        <div className="casino-table">
          <ul className="mb-1 nav nav-pills" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                type="button"
                id="uncontrolled-tab-example-tab-hands"
                role="tab"
                data-rr-ui-event-key="hands"
                aria-controls="uncontrolled-tab-example-tabpane-hands"
                aria-selected={activeTab === "hands"}
                className={`nav-link ${activeTab === "hands" ? "active" : ""}`}
                onClick={() => setActiveTab("hands")}
              >
                Hands
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                type="button"
                id="uncontrolled-tab-example-tab-pattern"
                role="tab"
                data-rr-ui-event-key="pattern"
                aria-controls="uncontrolled-tab-example-tabpane-pattern"
                aria-selected={activeTab === "pattern"}
                className={`nav-link ${
                  activeTab === "pattern" ? "active" : ""
                }`}
                onClick={() => setActiveTab("pattern")}
              >
                Pattern
              </button>
            </li>
          </ul>
          <div className="tab-content">
            <div
              role="tabpanel"
              id="uncontrolled-tab-example-tabpane-hands"
              aria-labelledby="uncontrolled-tab-example-tab-hands"
              // className="fade hands tab-pane active show"
              className={`fade pattern tab-pane  ${
                activeTab === "hands" ? "active show" : ""
              }`}
            >
              <div className="row row5">
                <div className="col-md-6">
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player 1", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">
                      Player 1
                      <div className="patern-name ms-3">
                        <span className="card-icon ms-2">
                          K<span className="card-red ms-1" />
                        </span>
                        <span className="card-icon ms-2">
                          4<span className="card-red ms-1" />
                        </span>
                      </div>
                    </div>
                    <p className="casino-odds d-none d-md-block">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player 1")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Player 1", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player 2", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">
                      Player 2
                      <div className="patern-name ms-3">
                        <span className="card-icon ms-2">
                          5<span className="card-red ms-1" />
                        </span>
                        <span className="card-icon ms-2">
                          J<span className="card-black ms-1" />
                        </span>
                      </div>
                    </div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player 2")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Player 2", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player 3", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">
                      Player 3
                      <div className="patern-name ms-3">
                        <span className="card-icon ms-2">
                          10<span className="card-red ms-1" />
                        </span>
                        <span className="card-icon ms-2">
                          Q<span className="card-red ms-1" />
                        </span>
                      </div>
                    </div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player 3")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Player 3", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player 4", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">
                      Player 4
                      <div className="patern-name ms-3">
                        <span className="card-icon ms-2">
                          8<span className="card-red ms-1" />
                        </span>
                        <span className="card-icon ms-2">
                          6<span className="card-black ms-1" />
                        </span>
                      </div>
                    </div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player 4")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Player 4", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player 5", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">
                      Player 5
                      <div className="patern-name ms-3">
                        <span className="card-icon ms-2">
                          9<span className="card-red ms-1" />
                        </span>
                        <span className="card-icon ms-2">
                          A<span className="card-black ms-1" />
                        </span>
                      </div>
                    </div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player 5")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Player 5", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player 6", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">
                      Player 6
                      <div className="patern-name ms-3">
                        <span className="card-icon ms-2">
                          3<span className="card-black ms-1" />
                        </span>
                        <span className="card-icon ms-2">
                          6<span className="card-red ms-1" />
                        </span>
                      </div>
                    </div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player 6")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Player 6", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              role="tabpanel"
              id="uncontrolled-tab-example-tabpane-pattern"
              aria-labelledby="uncontrolled-tab-example-tab-pattern"
              className={`fade pattern tab-pane  ${
                activeTab === "pattern" ? "active show" : ""
              }`}
            >
              <div className="row row5">
                <div className="col-md-4 col-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("High Card", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">High Card</div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(casinoPlData, "High Card")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("High Card", casinoData, true)}{" "}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() => setBet("Pair", casinoData, dispatch, "back")}
                  >
                    <div className="casino-nation-name">Pair</div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Pair")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Pair", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Two Pair", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">Two Pair</div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Two Pair")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Two Pair", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Three of a Kind", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">Three of a Kind</div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(
                        casinoPlData,
                        "Three of a Kind"
                      )}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Three of a Kind", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Straight", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">Straight</div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Straight")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Straight", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Flush", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">Flush</div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Flush")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Flush", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Full House", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">Full House</div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(casinoPlData, "Full House")}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Full House", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Four of a Kind", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">Four of a Kind</div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(
                        casinoPlData,
                        "Four of a Kind"
                      )}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Four of a Kind", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-6">
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Straight Flush", casinoData, dispatch, "back")
                    }
                  >
                    <div className="casino-nation-name">Straight Flush</div>
                    <p className="casino-odds d-none d-md-block ">
                      {getCasinoPlExposureByRunner(
                        casinoPlData,
                        "Straight Flush"
                      )}
                    </p>
                    <div>
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Straight Flush", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="casino-remark mt-1">
            <marquee scrollamount={3}> </marquee>
          </div>
        </div>
      </div>

      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
